import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateCurrentBlockState } from "../../../Redux/actions/projectActions";
import Block from "../Preview/Block/Block";
import { scrollxLogo } from "../../../assets/icons";
import "../../../assets/styles/FontsStyle.css";
import "./CardPreview.css";
import Footer from "../Footer/Footer";
import { getProjectBackgroundStyle } from "../utils/projectBackground";

import { toast } from "react-toastify";
import CustomToast, { customToatStyle } from "../../../Components/CustomToast/CustomToast";
import hexToRgba from "../../Projects/utils/hexToRgba";
// import { customToatStyle } from "../Options/OptionBlocks/Logos/Logos";

// Keep inset in-flow. Floats collapse the wrapper and skip PNG capture.
const blockInsetClass = {
  default: "w-[100%] ",
  left: "w-[50%] mr-auto",
  right: "w-[50%] ml-auto",
};

const focusDiv = (idx, currentIdx) => {
  if (idx === currentIdx) {
    return "CardfocusDiv";
  } else {
    return "";
  }
};

const scrollTo = (parent, child, slct, size) => {
  let parent1 = document.getElementById(parent);
  let child1 = document.getElementById(child);

  if (child1 && parent1) {
    parent1?.scrollTo({
      behavior: "smooth",
      top:
        slct === "font"
          ? child1.offsetTop -
            document.getElementById("navbar_1").offsetHeight +
            (size.winWidth <= "2560"
              ? size.winWidth <= "2310"
                ? size.winWidth <= "2050"
                  ? size.winWidth <= "1950"
                    ? size.winWidth <= "1800"
                      ? size.winWidth <= "1600" ? 35 : 55 : 10 : -20 : -25 : -36 : -50)
          : child1.offsetTop -
            document.getElementById("navbar_1").offsetHeight -
            150,
    });
  }
};

const endLines = (extra_lines_below, idx) => {
  if (extra_lines_below !== "") {
    return (
      <div id={idx + "endlines"}>
        {[...Array(extra_lines_below)].map((e, i) => (
          <br></br>
        ))}
      </div>
    );
  } else {
    return <div id={idx + "endlines"}></div>;
  }
};

const calculateAspectRatio = (width, height) => {
  if (!width || !height) return null;

  const aspectRatio = (width / height).toFixed(8); // Calculate aspect ratio and round to 2 decimal places

  if (aspectRatio === "1.77777778") {
    return "16:9"; // Example: 1920x1080
  } else if (aspectRatio === "1.33333333") {
    return "4:3"; // Example: 1920x1440
  } else if (aspectRatio === "2.38694639") {
    return "CinemaScope"; // Example: 2048x858
  } else if (aspectRatio === "2.00000000") {
    return "Univisium";
  } else if (aspectRatio === "1.85000000") {
    return "flat";
  } else if (aspectRatio === "1.89629630") {
    return "DCI 4K";
  } else if (aspectRatio === "2.38805970") {
    return "CinemaScope2";
  } else {
    return `${aspectRatio}`; // Return the calculated ratio if it's not predefined
  }
};

const applyAspectRatioStyles = (resolution) => {
  if (!resolution || !resolution.videoWidth || !resolution.videoHeight) {
    return {};
  }

  const aspectRatio = calculateAspectRatio(
    resolution.videoWidth,
    resolution.videoHeight
  );

  // Apply styles based on aspect ratio
  switch (aspectRatio) {
    case "16:9":
      return { aspectRatio: "1.77777778 / 1", border: "1px solid #0e0c1a" };
    case "4:3":
      return { aspectRatio: "1.33333333 / 1", border: "1px solid #0e0c1a" };
    case "CinemaScope":
      return { aspectRatio: "2.38694639 / 1", border: "1px solid #0e0c1a" };
    case "CinemaScope2":
      return { aspectRatio: "2.38805970 / 1", border: "1px solid #0e0c1a" };
    case "Univisium":
      return { aspectRatio: "2.00000000 / 1", border: "1px solid #0e0c1a" };
    case "flat":
      return { aspectRatio: "1.85000000 / 1", border: "1px solid #0e0c1a" };
    case "DCI 4K":
      return { aspectRatio: "1.89629630 / 1", border: "1px solid #0e0c1a" };
    default:
      return { padding: "0px" };
  }
};

const CardPreview = ({ projectData, isFullscreen, exitFullscreen,isDisplayTitle, isRenderExport, setIsRenderExport, blocks }) => {
  const overflowBlocksRef = useRef(null);
  const SINGLE_TOAST_ID = "text-overflow-toast";

  if (!overflowBlocksRef.current) {
    overflowBlocksRef.current = new Map();
  }


  const { resolution } = projectData;
  const dispatch = useDispatch();
  const previewRef = useRef(null);
  const isOptionSelected = useSelector((state) => state.commonReducer.isOptionSelected);
  const { previewWidth, previewScale } = useSelector((state) => state?.application);

  const { renderPlan, currentPlan } = useSelector((state) => state.commonReducer);
  const [isUserPaid, setIsUserPaid] = useState(Boolean(currentPlan.success && currentPlan.plan));
  useEffect(() => {
    setIsUserPaid(Object.keys(currentPlan).length > 0);
  }, [currentPlan]);
  // console.log('isUserPaid =', isUserPaid);

  useEffect(()=>{
    if(isRenderExport){
      window.location.reload();
      setIsRenderExport((prev) => !prev)
    }
  },[isRenderExport])

  // Preview Full Screen
  const [size, setSize] = useState({winWidth: window.innerWidth, winHeight: window.innerHeight});
  const detectSize = () => {setSize({ winWidth: window.innerWidth, winHeight: window.innerHeight})};
  useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [size]);

  const currentBlockIdx = projectData?.currentBlock?.idx;

  useEffect(() => {
    scrollTo("preview", "view_" + currentBlockIdx, isOptionSelected, size);
    scrollTo("content", "content" + currentBlockIdx, size);
  }, [currentBlockIdx, isOptionSelected]);

useEffect(() => {
    const previewEl = previewRef.current;
    if (!previewEl || !blocks?.length) return;
  
    const checkOverlayHeight = () => {
      const overlays = previewEl.querySelectorAll(".overlaytext");
      if (!overlays.length) return;
  
      overlays.forEach((overlay) => {
        const blockWrapper = overlay.closest(".blockWrapper");
        if (!blockWrapper) return;
  
        const overlayHeight = overlay.scrollHeight;
        const blockHeight = blockWrapper.clientHeight;
  
        const viewEl = blockWrapper.id || "";
        const extractBlockIndex = Number(viewEl.replace("view_", ""));
  
        if (Number.isNaN(extractBlockIndex)) return;
  
        const overlayBlockName =
          blocks?.[extractBlockIndex]?.block_name || `Block ${extractBlockIndex}`;
  
        if (overlayHeight > blockHeight) {
          overflowBlocksRef.current.set(extractBlockIndex, {
            index: extractBlockIndex,
            name: overlayBlockName,
          });
          overlay.style.pointerEvents = "none";
        } else {
          overlay.style.pointerEvents = "auto";
          overflowBlocksRef.current.delete(extractBlockIndex);
        }
      });
  
      const blocksArray = [...overflowBlocksRef.current.values()];
  
      // ✅ stable toast state (no spam / no crash)
      if (!window.__overflowToastState) {
        window.__overflowToastState = { count: 0 };
      }
  
      const prevCount = window.__overflowToastState.count;
      const newCount = blocksArray.length;
  
      if (newCount > 0 && prevCount !== newCount) {
        window.__overflowToastState.count = newCount;
  
        toast(
          React.createElement(CustomToast, {
            title: "Text Overflow",
            blocks: blocksArray,
            isNotifyMultiple: true,
          }),
          {
            ...customToatStyle,
            toastId: SINGLE_TOAST_ID,
          }
        );
      }
  
      if (newCount === 0 && prevCount !== 0) {
        window.__overflowToastState.count = 0;
        toast.dismiss(SINGLE_TOAST_ID);
      }
    };
  
    // ✅ delay to wait DOM render (IMPORTANT)
    const timer = setTimeout(checkOverlayHeight, 10);
  
    // ✅ resize observer (fix font-size / height change bug)
    const observer = new ResizeObserver(checkOverlayHeight);
    previewEl.querySelectorAll(".blockWrapper").forEach((el) => observer.observe(el));
  
    window.addEventListener("resize", checkOverlayHeight);
  
    return () => {
      clearTimeout(timer);
      observer.disconnect();
      window.removeEventListener("resize", checkOverlayHeight);
    };
  }, [blocks, projectData]);

  
  const onclick = (currentCreditBlockId, idx) => {
    dispatch(updateCurrentBlockState(currentCreditBlockId, idx));
    scrollTo("preview", "view_" + idx, isOptionSelected, size);
    scrollTo("content", "content" + idx, size);
  };

// const handleBlockClick = (blockId, idx) => {
//   dispatch(updateCurrentBlockState(blockId, idx));
//   scrollTo("preview", `view_${idx}`, isOptionSelected, size);
//   scrollTo("content", `content${idx}`, size);
// };


  const blockArr = projectData?.credits?.map(
    ({ options, items, _id }, idx) => ({
      block: (
        <div
          key={idx}
          className={`h-full  ${
            blockInsetClass[options.block_inset]
          } viewBlock${focusDiv(idx, currentBlockIdx)}`}
          block-title={options.block_name}
          // onClick={() => handleBlockClick(_id, idx)}
          onClick={() => onclick(_id, idx)}
        >
          {projectData?.settings && (
            <Block
              options={options}
              items={items}
              idx={idx}
              settings={projectData?.settings}
            />
          )}
          {endLines(options.extra_lines_below, idx)}
        </div>
      ),
      idx,
      side_by_side: options.block_inset,
    })
  );

  let sideBySideBlocks = [];

  const previewBgStyle = getProjectBackgroundStyle(projectData?.settings);
    console.log('previewBgStyle => ', previewBgStyle?.backgroundColor);

  let gobalBGcolor = previewBgStyle?.backgroundColor;
  console.log('gobalBGcolor => ', gobalBGcolor);

  const globalBgColorOpacity = hexToRgba(gobalBGcolor, 0.3);

  const aspectRatioStyles = {
    ...applyAspectRatioStyles(resolution),
    ...previewBgStyle,
  };

  return (
    <div className="previewCnt w-full h-full">
      <div
        id="preview"
        className="Cardscrollable"
        ref={previewRef}
        style={previewBgStyle}
      >
        {blockArr?.map((data, idx) => {
          const blockName =
            projectData?.credits[idx]?.options?.block_name || `Block ${idx}`;

          if (data.side_by_side === "sidebyside") {
            sideBySideBlocks.push(idx, idx + 1);
            return (
              <div className="w-full">
                <div key={`block-group-${idx}`}>
                <div id={`Block${idx}`} className="blockName text-xl text-gray-500 text-left">Card {`${idx + 1}`}: {blockName}</div>
                <div className="aspectRatioClassStyle" style={aspectRatioStyles}>
                  <div key={idx} id={`view_${idx}`} className="blockWrapper pr-prants min-h-full h-full"
                    style={{width: isFullscreen ? "100%" : `${previewWidth * previewScale}px`}}
                  >
                 <div className={isDisplayTitle ? 'displayTitle' : ""}></div>

                    <div className={isUserPaid ? '' : "watermark"}></div>
                    <div className="flex flex-row gap-x-[30px] w-full"
                      style={{transformOrigin: "top left", height: "100%"}}
                    >
                      <div className={`w-[50%] ${idx === currentBlockIdx ? "CardfocusDiv" : ""}`}>{data.block}</div>
                      <div className={`w-[50%] ${idx + 1 === currentBlockIdx ? "CardfocusDiv" : ""}`}>{blockArr[idx + 1]?.block}</div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            );
          } else if (blockArr[idx - 1]?.side_by_side !== "sidebyside") {
            return (
              <div key={`block-${idx}`} className="w-full my-[50px]" style={{ width: "inherit" }}>
                <div className="overflow-hidden pb-[20px]">
                <div id={`Block${idx}`} className="blockName text-xl text-gray-500 text-left">Card {`${idx + 1}`}: {blockName}</div>
                <div className="flex items-center justify-center aspectRatioClassStyle" style={aspectRatioStyles}>
                  <div key={idx} id={`view_${idx}`} className={`blockWrapper pr-prants w-full min-h-full h-full ${idx === currentBlockIdx ? "CardfocusDiv" : ""}`}
                    style={{transformOrigin: "top left", height: "100%",
                      backgroundColor: gobalBGcolor === "#000000" && idx === currentBlockIdx ? "#0e0c1a" : hexToRgba(gobalBGcolor, 0.1),
                    }}
                  >
                 <div className={isDisplayTitle ? 'displayTitle' : ""}></div>
                  <div className={isUserPaid ? '' : "watermark"}></div>
                    {data.block}
                  </div>
                </div>
                </div>
              </div>
            );
          }
        })}
      </div>

     
      {isFullscreen && <img src={scrollxLogo} alt="" className="fss2" />}
      {isFullscreen && (<button type="button" onClick={exitFullscreen} className={isFullscreen ? "fss" : "d-none"}><span className="uppercase Syne700">EXIT</span></button>)}
    </div>
  );
};

export default CardPreview;
